import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import classNames from 'classnames';

import { TABS } from './config';
import { SortType, TradingEventsListState } from './TradingEventsList.state';
import Icon from '../../Icon/Icon';

interface PropsType {
    tradingEventsListState: TradingEventsListState,
}

export const TradingEventsListHeader = observer('TradingEventsListHeader', (props: PropsType) => {
    const { tradingEventsListState } = props;
    const { tab, sortColumn, sortDirection } = tradingEventsListState;

    const getSortArrow = (type: SortType | undefined): React.ReactElement | null => {
        if (type === undefined) {
            return null;
        }

        if (sortColumn === type) {
            if (sortDirection === 'up') {
                return <Icon name='up' />;
            } else {
                return <Icon name='down' />;
            }
        }

        return <Icon name='up' />;
    };

    const getClassName = (column: SortType): string => classNames([
        { 'active-sort': sortColumn === column }
    ]);

    const getSortEvents = (column: SortType | undefined) => (event: React.MouseEvent): void => {
        event.preventDefault();
        tradingEventsListState.sortEvents(column);
    };

    const renderColumnLink = (key: string | null, className: string | null, columnSortOption: SortType | undefined, content: string): React.ReactNode => {
        if (columnSortOption === undefined) {
            return (
                <th
                    key={key}
                    className={className ?? undefined}
                >
                    { content }
                </th>
            );
        }

        return (
            <th
                key={key}
                className={className ?? undefined}
                onClick={getSortEvents(columnSortOption)}
            >
                <a
                    href='#'
                    className={getClassName(columnSortOption)}
                >
                    { content }
                </a>
                { getSortArrow(columnSortOption) }
            </th>
        );
    };

    return (
        <thead>
            <tr>
                <th />
                { renderColumnLink(
                    'key-startTime',
                    null,
                    'timeSettings.startTime',
                    'Time'
                )}
                <th>
                    Sport
                </th>
                { renderColumnLink(
                    'key-name',
                    'trading-events-list-table-name-header',
                    'name',
                    'Event'
                )}
                { TABS[tab].map((column) =>
                    renderColumnLink(
                        column.key,
                        'trading-events-list-table-additional',
                        column.sort,
                        column.name
                    )
                )}
            </tr>
        </thead>
    );
});

